//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';

//local imports
import { ProgramModel } from '@app/catalog';
import { PresenterType } from '@app/shared';




@PresenterType({
  model: ProgramModel,
  key: 'tileTop'
})
@Component({
  selector: 'program-carousel-item',
  templateUrl: './program-carousel-item.component.html',
  styleUrl: './program-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProgramCarouselItemComponent {
  public data: WritableSignal<ProgramModel> = signal<ProgramModel>(undefined);
}
